import React from 'react';
import { Provider } from './context';

const RestrictProvider = ({ children, privileges = [] }) => (
  <Provider value={privileges}>{children}</Provider>
);

export default RestrictProvider;
